var DecimalNumber = {
  print: function print(_ref) {
    var node = _ref.node;
    return node.value;
  }
};
module.exports = DecimalNumber;